<!-- Admin Edit Article Meta Data -->

<template>
	<div class="adm-edit-met">

		<div class="lab-box">Live:</div>
		<div :class="(rec.live=='1')? 'chk-box active': 'chk-box'" @click="clickLive">
			<UniIcon 
				:ico="(rec.live=='1')? 'check': 'cancel'" 
				:color="(rec.live=='1')? '#FFF': '#C30'" 
				fit="1"
				pad="0"				
			/>
		</div>

		&nbsp; &nbsp; 
		<div class="lab-box">RID: {{ rec.rid }}</div>
		<span style="float:right">{{ rec.catTitle }}</span>

		<div class="v-spacer" />

		<div class="lab-box">Item ID:</div>
		<div class="pop-value-box" @click="popInput('itemId')" v-html="convertLFs(rec.itemId)"></div>

		<div class="v-spacer" />

		<div class="lab-box">Pix ID:</div>
		<div class="pop-value-box" @click="popInput('pixId')" v-html="convertLFs(rec.pixId)"></div>

		<div class="v-spacer" />

		<div class="lab-box">Stage:</div>
		<div class="pop-value-box" @click="popInput('stage')" v-html="convertLFs(rec.stage)"></div>

		<div class="v-spacer" />

		<div class="lab-box">Merit:</div>
		<div class="pop-value-box" @click="popInput('merit')" v-html="convertLFs(rec.merit)"></div>

		<div class="v-spacer" />

		<div class="lab-box">Descr:</div>
		<div class="pop-value-box" @click="popInput('descr')" v-html="convertLFs(rec.descr)"></div>

		<div class="v-spacer" />

		<div class="lab-box">Notes:</div>
		<div class="pop-value-box" @click="popInput('notes')" v-html="convertLFs(rec.notes)"></div>

		<div class="v-spacer" />

		<div class="lab-box">Pix Qty:</div>
		<div class="val-box">
			{{ pix.length }}
		</div>

		<div class="v-spacer" />

		<div class="lab-box">Rem Addr:</div>
		<div class="val-box">
			{{ rec.remAddr }}
		</div>

		<div class="v-spacer" />

		<div class="lab-box">Rem Host:</div>
		<div class="val-box">
			{{ rec.remHost }}
		</div>

		<div class="v-spacer" />

		<div class="lab-box">Log ID:</div>
		<div class="val-box">
			{{ rec.logId }}
		</div>

		<div class="v-spacer" />

		<div class="lab-box">Browser:</div>
		<div class="val-box-2" v-html="rec.browser">
		</div>

	</div>
</template>

<script>
import { m } from "@/utils/utils"
import * as Utils from "@/utils/utils"
import { mapState } from 'vuex';
import { eventBus } from "@/main";
export default {
	data() {
		return {
			rec: {},
			pix: [],
		}
	},
	computed: {
		...mapState('app',['current']),
	},
	methods: {
		popInput(colName) {
			Utils.showPopInput(colName, this.rec[colName]);
		},
		handleUpdateVal(payload) {
			let colName = payload.colName;
			let val = payload.val;
			this.rec[colName] = val;
			if(payload.colName=="dateCre") this.checkDate();		
		},
		convertLFs(str1="") {
			m("convert LFs", str1);
			let str2 = str1.replace(/\n/g, '<br/>', );
			return str2;
		},
		clickLive() {
			m("click live");
			this.rec.live = (this.rec.live=='1')? '': '1';
			this.updateRec(); // Light up the gear in the parent tab
		},
		updateRec() {
			let payload = {
				art: this.rec,
			}
			this.$store.dispatch("app/setArt", payload);
		},
	},
	mounted() {
		m("adm edit met mounted");
		this.rec = {...this.current.art};
		this.pix = [...this.current.pix];
		m("adm edit met rec", this.rec);
		m("adm edit met pix", this.pix);
	},
	created() {
		eventBus.$on('update-value', this.handleUpdateVal);
	},
	beforeDestroy() {
		m("adm edit met before destroy");
		this.updateRec();
		eventBus.$off('update-value', this.handleUpdateVal);
	},
}
</script>

<style scoped>

.adm-edit-met {
	height: 100%;
	overflow: hidden;
	border: solid 0px #C30;
}

.lab-box {
	display: inline-block;
	width: 70px;
	height: 28px;
	overflow: hidden;
	vertical-align: top;
	white-space: nowrap;
	padding: 2px;
	border: solid 0px #369;
}

.pop-value-box {
	display: inline-block;
	width: 210px;
	height: 25px;
	overflow: hidden;
	vertical-align: top;
	cursor: pointer;
	background-color: #FFF;
	border: solid 1px #999;
}

.pop-textarea {
	height: 120px;
	width: 310px;
	overflow-x: none;
	overflow-y: auto;
}

.val-box {
	display: inline-block;
	/* width: 220px; */
	width: calc(100% - 90px);
	height: 25px;
	overflow: hidden;
	vertical-align: top;
	white-space: nowrap;
	border: solid 0px #090;
}

.chk-box {
	display: inline-block;
	width: 30px;
	height: 30px;
	overflow: hidden;
	vertical-align: top;
	white-space: nowrap;
	cursor: pointer;
	border-radius: 4px;
	border: solid 1px #999;
}

.active {
	background-color: #393;
}

.val-box-2 {
	display: inline-block;
	width: calc(100% - 80px);
	height: 70px;
	overflow: auto;
	/* white-space: nowrap; */
	vertical-align: top;
	border: solid 1px #CCC;
}

.v-spacer {
	width: 10px;
	height: 3px;
	vertical-align: top;
	border: solid 0px #999;
}

input {
	width: 100%;
}

textarea {
	width: 100%;
	height: 100%;
	resize: none;
}

</style>
